// extracted by mini-css-extract-plugin
module.exports = {"container":"BaseLayout_container__pHsIa","content":"BaseLayout_content__c30BI"};